import {obtainClientId} from "../utils/auth";

export default {
    isInited: false,
    isAnon: false,
    //initedWithImKey: false,

    user: null,
    workspace: null,
    ims: null,

    currentTask: {
        item: null,
        timer: null,
        totalTime: 0,
    },

    oneTask: {
        item: null,
    },
    totalTasks: null,

    /**
     * Current environment: workspaces / lists / contexts / groups / topics / users
     */
    area: {
        workspaces: null,
        picks: null,
        groups: null,
        topics: null,
        favoriteUsers: null,
        users: null,
        onlineUsers: null,
        countUnreadEvens: null,
    },
}